import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NameSectionForm from '../../../../../ReusableFormSections/NameSection/NameSectionForm'

import { clearUpdateLineItem, updateLineItem } from '../../../../../../modules/actions/lineItems'

import { selectedFacebookAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'
import {
  lineItemUpdateErrorSelector,
  lineItemUpdateIsLoadingSelector,
  lineItemWasUpdatedSelector
} from '../../../../../../modules/selectors/lineItems'
import { campaignSelector } from '../../../../../../modules/selectors/campaigns'

import { FACEBOOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const NameSection = ({ editItemData: lineItem, title, ...formProps }) => {
  const dispatch = useDispatch()

  const lineItemWasUpdated = useSelector(lineItemWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedFacebookAdAccountSelector)
  const { objective: campaignObjective } = useSelector(campaignSelector)

  const handleSubmit = useCallback(
    values => {
      const updateLineItemData = {
        account: selectedAdAccountId,
        campaign_objective: campaignObjective,
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        },
        ...values
      }

      dispatch(updateLineItem(updateLineItemData, lineItem.id, FACEBOOK_PLATFORM))
    },
    [dispatch, lineItem.id, campaignObjective, selectedAdAccountId, title]
  )

  const handleClearUpdateLineItem = useCallback(() => {
    dispatch(clearUpdateLineItem())
  }, [dispatch])

  return (
    <NameSectionForm
      placeholder="Ad Set Name"
      editItem={lineItem}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearUpdateLineItem}
      successSubmit={lineItemWasUpdated}
      isLoadingSelector={lineItemUpdateIsLoadingSelector}
      errorSelector={lineItemUpdateErrorSelector}
      {...formProps}
    />
  )
}

export default NameSection
